(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./dialog.less", "../popup", "../icon", "../button", "../_util", "../_mixins/dialogBounce", "./utils/index.js", "@better-scroll/core", "@better-scroll/scroll-bar", "@better-scroll/observe-dom", "../_mixins/osProps"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./dialog.less"), require("../popup"), require("../icon"), require("../button"), require("../_util"), require("../_mixins/dialogBounce"), require("./utils/index.js"), require("@better-scroll/core"), require("@better-scroll/scroll-bar"), require("@better-scroll/observe-dom"), require("../_mixins/osProps"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.dialog, global.popup, global.icon, global.button, global._util, global.dialogBounce, global.index, global.core, global.scrollBar, global.observeDom, global.osProps);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _dialog, _popup, _icon, _button, _util, _dialogBounce, _index, _core, _scrollBar, _observeDom, _osProps) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _popup = _interopRequireDefault(_popup);
  _icon = _interopRequireDefault(_icon);
  _button = _interopRequireDefault(_button);
  _dialogBounce = _interopRequireDefault(_dialogBounce);
  _core = _interopRequireDefault(_core);
  _scrollBar = _interopRequireDefault(_scrollBar);
  _observeDom = _interopRequireDefault(_observeDom);
  _osProps = _interopRequireDefault(_osProps);

  var _components;

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  _core.default.use(_scrollBar.default);

  _core.default.use(_observeDom.default);

  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        class: {
          'nx-dialog': true,
          'nx-os-blur-material': _vm.blurMaterial
        },
        attrs: {
          "id": _vm.id
        }
      }, [_c('nx-popup', {
        ref: "bounceDialog",
        attrs: {
          "value": _vm.value,
          "hasMask": _vm.hasMask,
          "lockScroll": _vm.lockScroll,
          "maskClosable": _vm.maskClosable,
          "position": _vm.position,
          "transition": _vm.transition,
          "preventScroll": _vm.preventScroll,
          "multiplePopup": _vm.multiplePopup,
          "preventScrollExclude": _vm.preventScrollExclude,
          "is-webview-full": _vm.isWebviewFull,
          "ariaPopupLabel": _vm.ariaPopupLabel,
          "slideDownDisappear": _vm.slideDownDisappear,
          "backClosePopup": _vm.backClosePopup,
          "backClosePopupCustomEvent": _vm.backClosePopupCustomEvent
        },
        on: {
          "input": _vm.$_onInput,
          "show": _vm.$_onShow,
          "hide": _vm.$_onHide,
          "maskClick": _vm.$_maskClick,
          "beforeHide": _vm.$_beforeClose
        }
      }, [_c('div', {
        staticClass: "nx-dialog-content",
        class: [!_vm.title && _vm.btnsTransfer.length < 1 ? 'no-title-btns' : '', _vm.limitMaxHeight ? '' : 'nx-dialog-content-no-max-height', _vm.vscroll ? 'nx-dialog-content-vscroll' : '']
      }, [_vm._t("header"), _c('div', {
        staticClass: "nx-dialog-body",
        class: [_vm.btnsTransfer.length > 0 ? 'btn-padding' : '', _vm.vscroll ? 'vscroll' : '', _vm.btnsTransfer.length == 1 ? 'vscroll1' : 'vscroll2']
      }, [_vm.closable ? _c('a', {
        staticClass: "nx-dialog-close",
        attrs: {
          "role": "button",
          "aria-label": "关闭"
        },
        on: {
          "click": _vm.close
        }
      }, [_c('nx-icon', {
        attrs: {
          "name": "close2"
        }
      })], 1) : _vm._e(), _vm.icon ? _c('div', {
        staticClass: "nx-dialog-icon"
      }, [_c('nx-icon', {
        attrs: {
          "name": _vm.icon,
          "svg": _vm.iconSvg
        }
      })], 1) : _vm._e(), !_vm.title && !_vm.$slots.title ? _c('div', {
        staticClass: "nx-dialog-notitle"
      }) : _c('div', {
        staticClass: "nx-dialog-title-wrap"
      }, [_vm.$slots.title ? _vm._t("title") : _c('div', {
        staticClass: "nx-dialog-title",
        style: _vm.titleStyle,
        attrs: {
          "nx-popup-aria-auto-focus": "true",
          "aria-label": _vm.ariaLabelTile || _vm.title
        },
        domProps: {
          "textContent": _vm._s(_vm.title)
        },
        on: {
          "touchstart": _vm.handleTouchstart,
          "touchmove": _vm.handleTouchmove,
          "touchend": function touchend($event) {
            return _vm.handleTouchend(_vm.close);
          }
        }
      }), _vm.subTitle ? _c('div', {
        staticClass: "nx-dialog-subtitle",
        domProps: {
          "textContent": _vm._s(_vm.subTitle)
        }
      }) : _vm._e()], 2), _c('div', {
        ref: "dialog-scrollbar-body",
        staticClass: "nx-dialog-body-content__container",
        class: ["nx-dialog-body-content__container_" + _vm.btnsTransfer.length, "" + (_vm.title ? '' : 'nx-dialog-body-content__container_notitle'), _vm.vscroll ? 'vscroll' : '']
      }, [_c('div', {
        staticClass: "scroll-children"
      }, [_vm.content ? _c('div', {
        class: ['nx-dialog-text', _vm.title ? '' : 'nx-dialog-text-no-title'],
        attrs: {
          "nx-popup-aria-auto-focus": "true",
          "aria-label": _vm.ariaLabelContent
        },
        domProps: {
          "innerHTML": _vm._s(_vm.content)
        }
      }) : _vm._e(), _vm._t("default")], 2)])]), _c('div', {
        class: "nx-dialog-actions nx-dialog-actions-" + _vm.btnsTransfer.length
      }, [_vm._l(_vm.btnsTransfer, function (btn, index) {
        return [_c('nx-button', {
          key: index,
          staticClass: "nx-dialog-btn",
          class: {
            warning: !btn.disabled && !!btn.warning
          },
          style: Object.assign({}, {
            color: btn.color || ''
          }, btn.styles),
          attrs: {
            "type": btn.type,
            "disabled": btn.disabled,
            "round": "",
            "tagProps": btn.tagProps,
            "aria-hidden": btn.ariaHidden
          },
          on: {
            "click": function click($event) {
              return _vm.$_onClick(btn);
            },
            "clickWithEvent": function clickWithEvent(e) {
              return _vm.$_onClickWithEvent(btn, e);
            },
            "touchmove": function touchmove($event) {
              $event.preventDefault();
            }
          }
        }, [btn.icon || btn.iconSvg ? _c('nx-icon', {
          staticClass: "nx-dialog-btn-icon",
          attrs: {
            "aria-hidden": "true",
            "name": btn.icon,
            "svg": btn.iconSvg,
            "size": "md"
          }
        }) : _vm._e(), _c('span', [_vm._v(_vm._s(btn.text))])], 1)];
      })], 2)], 2)])], 1);
    },
    name: 'nx-dialog',
    components: (_components = {}, (0, _defineProperty2.default)(_components, _popup.default.name, _popup.default), (0, _defineProperty2.default)(_components, _icon.default.name, _icon.default), (0, _defineProperty2.default)(_components, _button.default.name, _button.default), _components),
    mixins: [_dialogBounce.default, _osProps.default],
    props: {
      id: {
        type: String,
        default: ''
      },
      value: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: ''
      },
      titleStyle: {
        type: Object
      },
      subTitle: {
        type: String,
        default: ''
      },
      position: {
        type: String,
        default: function _default() {
          if ((0, _index.$_isPad)()) {
            return 'center';
          }

          return 'bottom';
        }
      },
      icon: {
        type: String,
        default: ''
      },
      iconSvg: {
        type: Boolean,
        default: false
      },
      closable: {
        type: Boolean,
        default: false
      },
      content: {
        type: String,
        default: ''
      },
      closeDelMode: {
        type: Boolean,
        default: false
      },
      btns: {
        type: Array,
        default: function _default() {
          /* istanbul ignore next */
          return [];
        }
      },
      appendTo: {
        default: function _default() {
          return _util.mdDocument.body;
        }
      },
      lockScroll: {
        type: Boolean,
        default: true
      },
      hasMask: {
        type: Boolean,
        default: true
      },
      maskClosable: {
        type: Boolean,
        default: false
      },
      transition: {
        type: String,
        default: function _default() {
          if ((0, _index.$_isPad)()) {
            return 'nx-rebound';
          }

          return 'nx-slide-up';
        }
      },
      preventScroll: {
        type: Boolean,
        default: false
      },
      preventScrollExclude: {
        type: String,
        default: ''
      },
      isWebviewFull: {
        type: Boolean,
        default: function _default() {
          if (_util.isCombineWallet && location.href && location.href.indexOf('sink=1') > -1) {
            return true;
          } else {
            return false;
          }
        }
      },
      ariaLabelTile: {
        type: String,
        default: ''
      },
      ariaLabelContent: {
        type: String
      },
      ariaPopupLabel: {
        type: String,
        default: '弹出式窗口，'
      },
      slideDownDisappear: {
        default: undefined
      },
      backClosePopup: {
        type: Boolean,
        default: false
      },
      backClosePopupCustomEvent: {
        type: String,
        default: 'popstate'
      },
      multiplePopup: {
        type: Boolean,
        default: false
      },
      vscroll: {
        type: Boolean,
        default: false
      },
      bScrollProps: {
        type: Object,
        default: function _default() {
          return {};
        }
      },
      limitMaxHeight: {
        type: Boolean,
        default: true
      }
    },
    data: function data() {
      return {
        scrollTop: 0,
        bodyscroll: null
      };
    },
    computed: {
      btnsTransfer: function btnsTransfer() {
        var btns = this.btns;

        if (btns.length === 2) {
          return btns.map(function (item) {
            if (!item.type || item.type === 'primary') {
              item.type = 'frame-plus';
            }

            return item;
          });
        } else {
          return btns;
        }
      }
    },
    mounted: function mounted() {
      var _this = this;

      if (this.appendTo) {
        this.appendTo.appendChild(this.$el);
      }

      if (this.vscroll) {
        this.$nextTick(function () {
          _this.bodyscroll = new _core.default(_this.$refs['dialog-scrollbar-body'], _objectSpread({
            click: true,
            bindToWrapper: !!_this.isWebviewFull,
            deceleration: 0.002,
            scrollY: true,
            observeDOM: true,
            swipeBounceTime: 200,
            scrollbar: {
              fade: true,
              fadeInTime: 300,
              fadeOutTime: 300
            }
          }, _this.bScrollProps));
        });
      }
    },
    beforeDestroy: function beforeDestroy() {
      if (this.appendTo && this.appendTo.contains(this.$el)) {
        this.appendTo.removeChild(this.$el);
      }

      if (this.vscroll) {
        var _this$bodyscroll;

        (_this$bodyscroll = this.bodyscroll) === null || _this$bodyscroll === void 0 ? void 0 : _this$bodyscroll.destroy();
        this.bodyscroll = null;
      }
    },
    methods: {
      // MARK: private methods
      // MARK: events handler
      $_onInput: function $_onInput(val) {
        this.$emit('input', val);
      },
      $_onShow: function $_onShow() {
        this.$_onRefresh();
        this.$emit('show');
      },
      $_onRefresh: function $_onRefresh() {
        var _this$bodyscroll2;

        // 暴露refresh方法；只考虑dialog
        (_this$bodyscroll2 = this.bodyscroll) === null || _this$bodyscroll2 === void 0 ? void 0 : _this$bodyscroll2.refresh();
      },
      $_onHide: function $_onHide() {
        this.$emit('hide');
      },
      $_maskClick: function $_maskClick() {
        this.$emit('maskClick');
      },
      $_onClick: function $_onClick(btn) {
        // 如果存在handlerWithEvent，则直接走下面的$_onClickWithEvent事件
        if (btn.disabled || btn.loading || btn.handlerWithEvent) {
          return;
        }

        if (typeof btn.handler === 'function') {
          btn.handler.call(null, btn);
        } else {
          this.close();
        }
      },
      $_onClickWithEvent: function $_onClickWithEvent(btn, e) {
        if (btn.disabled || btn.loading || !btn.handlerWithEvent) {
          return;
        }

        if (typeof btn.handlerWithEvent === 'function') {
          btn.handlerWithEvent.call(null, btn, e);
        } else {
          this.close();
        }
      },
      $_beforeClose: function $_beforeClose() {
        this.$emit('beforeClose');
      },
      // MARK: public methods
      close: function close() {
        this.$emit('closeIconClick');
        this.$emit('input', false);
      }
    }
  };
  _exports.default = _default2;
});